import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIBadgeComponent } from './badge.component';

@NgModule({
  declarations: [UIBadgeComponent],
  imports: [CommonModule],
  exports: [UIBadgeComponent],
})
export class UIBadgeModule {}
